import React from "react";
import { ISocieteDetails } from "../../../models/interfaces/ISociete";
import RowDetail from "../components/detail/RowDetail";
import RowDetailList from "../components/detail/RowDetailList";
import RowDetailListMemeLigne from "../components/detail/RowDetailListMemeLigne";
//Styles:

interface IProps {
    MarqueResult: ISocieteDetails;
}



const MarqueBloc2: React.FC<IProps> = ({
  MarqueResult
}) => {
  return (
    <div className="card-body pae-form-container">
    <div className="col-sm-12 card pae-detail-pub-card" style={{padding:"1%"}}>
   {MarqueResult?.Societe?.IdTypeActivite && (
            <RowDetail titre="Type de société" donnee={MarqueResult?.Societe?.IdTypeActivite}/>

          )}
          {MarqueResult?.Societe?.StatusSociete?.toUpperCase() !== 'N' && (
            <RowDetail
              titre="Statut"
              donnee={
                MarqueResult?.Societe?.StatusSociete?.toUpperCase() === 'F'
                  ? 'Inactif'
                  : MarqueResult?.Societe?.StatusSociete
              }
              color={MarqueResult?.Societe?.StatusSociete?.toUpperCase() === 'F' ? 'red' : undefined}
              
            />
          )}

          {MarqueResult?.Societe?.Nationalite && (
            <div style={{ marginBottom: '4px' }}>
              <RowDetail titre="Nationalité" donnee={MarqueResult?.Societe?.Nationalite} />
              </div>
          )}     
          {MarqueResult?.Societe?.FormeBibliographique && (
             <div style={{ marginBottom: '4px' }}>
            <RowDetail titre="Forme bibliographique" donnee={MarqueResult?.Societe?.FormeBibliographique} />
            </div>
          )} 
          {MarqueResult?.SegmentIsbn?.length > 0 && (
             <div style={{ marginBottom: '4px' }}>
            <RowDetailListMemeLigne titre="ISBN" donnees={MarqueResult?.SegmentIsbn?.map(e => e)} titreCol="4" donneeCol="8" />
            </div>
          )} 
          {MarqueResult?.Specialites?.length > 0 && (
             <div style={{ marginBottom: '4px' }}>
            <RowDetailList titre="Spécialités" donnees={MarqueResult?.Specialites?.map(e => e.SpecialiteLibelle)} titreCol="4" donneeCol="8"/>
            </div>
          )}    
</div>
</div>
  );
};

export default MarqueBloc2;
